namespace advisorop.components.servicer {


    export class CuAfcModelController {

        public advisoryFirmId: number;
        iAmReady: any; //event when controller has been initialised
        onModelsChange: any;

        public dgAfcModel: DevExpress.ui.dxDataGridOptions;
        public afcModel: domains.IAFAssetClassnModel = null;
        public afcModels: domains.IAFAssetClassnModel[] = [];
        public afcClasses: domains.IAFAssetClassnClassn[];
        public treeIsDirty = false;
        public classnsLoaded = false;
        public savingAfcClassn = false;
        public dgAfcModelComponentInstance: DevExpress.ui.dxDataGrid;

        public treeData = [
            {
                id: "1",
                parentId: "0",
                classification: "",
            }
        ];

        public treeListInstance: DevExpress.ui.dxTreeList;
        public treeListOptions: DevExpress.ui.dxTreeListOptions;

        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private gs: services.GeneralService) {

            this.dgAfcModel = {
                export: {
                    enabled: true,
                    fileName: "AFCModels"
                },
                bindingOptions: {
                    dataSource: "vm.afcModels"
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'name', caption: 'Name' },
                    //{ dataField: 'name', caption: 'Name', cellTemplate: 'tmpAfcModelName' },
                    //{ dataField: 'isLocked', caption: 'Is Locked', width: "120px", visible: true },
                    //{ dataField: 'isActive', caption: 'Is Active', width: "120px", visible: true },
                    { dataField: 'id', caption: '#', cellTemplate: 'tmpBtnActions', width: "80px", visible: true }
                ],
                selection: {
                    mode: 'single',
                    showCheckBoxesMode: 'onClick'
                },
                onSelectionChanged(selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onEditAfcModel(data);
                    }
                },
                onInitialized: (e) => {
                    this.dgAfcModelComponentInstance = e.component;
                },
            };

            this.treeListOptions = {
                autoExpandAll: true,
                columns: [{
                    dataField: 'classification',
                    caption: "Model Classification Tree"
                }],
                bindingOptions: {
                    dataSource: "vm.treeData"
                },
                keyExpr: "id",
                parentIdExpr: "parentId",
                showRowLines: false,
                editing: {
                    allowAdding: true,
                    allowDeleting: true,
                    allowUpdating: true,
                    form: null,
                    mode: "row",
                    popup: null,
                    refreshMode: "full",
                    selectTextOnEditStart: false,
                    startEditAction: "click",
                    texts: {
                        addRow: "Add a row",
                        addRowToNode: "Add",
                        cancelAllChanges: "Discard changes",
                        cancelRowChanges: "Cancel",
                        confirmDeleteMessage: "Are you sure you want to delete this record?",
                        confirmDeleteTitle: "",
                        deleteRow: "Delete",
                        editRow: "Edit",
                        saveAllChanges: "Save changes",
                        saveRowChanges: "Save",
                        undeleteRow: "Undelete",
                        validationCancelChanges: "Cancel changes"
                    },
                    useIcons: false,
                },
                rowDragging: {
                    data: this,
                    showDragIcons: true,
                    allowDropInsideItem: false,
                    allowReordering: true,
                    onDragChange(e) {
                        //console.log("IN ON DRAG CHANGE!!!");
                        var _this = e.fromData;
                        const visibleRows = _this.treeListInstance.getVisibleRows();
                        const sourceNode = _this.treeListInstance.getNodeByKey(e.itemData.id);
                        let targetNode = visibleRows[e.toIndex].node;

                        while (targetNode && targetNode.data) {
                            if (targetNode.data.id === sourceNode.data.id) {
                                e.cancel = true;
                                break;
                            }
                            targetNode = targetNode.parent;
                        }
                    },
                    onReorder(e) {
                        //console.log("IN ON REORDER!!!");
                        var _this = e.fromData;

                        const visibleRows = _this.treeListInstance.getVisibleRows();

                        if (e.dropInsideItem) {
                            e.itemData.parentId = visibleRows[e.toIndex].key;
                        } else {
                            const sourceData = e.itemData;
                            const toIndex = e.fromIndex > e.toIndex ? e.toIndex - 1 : e.toIndex;
                            let targetData = toIndex >= 0 ? visibleRows[toIndex].node.data : null;

                            if (targetData && _this.treeListInstance.isRowExpanded(targetData.id)) {
                                sourceData.parentId = targetData.id;
                                targetData = null;
                            } else {
                                sourceData.parentId = targetData ? targetData.parentId : _this.treeListInstance.option('rootValue');
                            }

                            const sourceIndex = _this.treeData.indexOf(sourceData);
                            _this.treeData.splice(sourceIndex, 1);

                            const targetIndex = _this.treeData.indexOf(targetData) + 1;
                            _this.treeData.splice(targetIndex, 0, sourceData);
                        }

                        _this.treeIsDirty = true;
                        _this.treeListInstance.refresh();
                    },
                },
                onInitialized: (e) => {
                    this.treeListInstance = e.component;
                },
                onRowInserted: (e) => {
                    this.treeIsDirty = true;
                },
                onRowUpdated: (e) => {
                    this.treeIsDirty = true;
                },
                onRowRemoved: (e) => {
                    this.treeIsDirty = true;
                },
                onRowInserting: (e) => {
                    if (this.afcModel.locked) {
                        toastr.warning(`You can not make changes to a locked model.`);
                        e.cancel = true;
                    }
                    if (e.data.parentId == domains.AssetClass.NO_ALLOCATION) {
                        toastr.warning(`You may not add subclassifications to the other/catch-all classification.`);
                        e.cancel = true;
                    }
                },
                onRowUpdating: (e) => {
                    if (this.afcModel.locked) {
                        toastr.warning(`You can not make changes to a locked model.`);
                        e.cancel = true;
                    }
                },
                onRowRemoving: (e) => {
                    if (this.afcModel.locked) {
                        toastr.warning(`You can not make changes to a locked model.`);
                        e.cancel = true;
                    }
                    if (e.data.id == domains.AssetClass.NO_ALLOCATION) {
                        toastr.warning(`You may not delete the other/catch-all classification.`);
                        e.cancel = true;
                    }
                },
            };
        }

        getCaption() {
            var ret = "Model Classification Tree";
            if (this.afcModel)
                ret += " for Model " + this.afcModel.name;
            return ret;
        }

        getTreeData() {
            return this.treeData;
        }

        newAfcModel() {
            this.dgAfcModelComponentInstance.deselectAll();
            this.classnsLoaded = false;
            this.afcModel = {
                id: 0,
                isActive: false,
                locked: false,
                name: "",
                advisoryFirmId: this.advisoryFirmId
            };
        }

        cancelNewAfcModel() {
            this.afcModel = null;
        }

        newTreeData() {
            return [
                {
                    id: domains.AssetClass.EQUITIES.toString(),
                    parentId: "0",
                    classification: "Equities",
                },
                {
                    id: domains.AssetClass.FIXED_INCOME.toString(),
                    parentId: "0",
                    classification: "Fixed Income",
                },
                {
                    id: domains.AssetClass.ALTERNATIVE_ASSETS.toString(),
                    parentId: "0",
                    classification: "Alternatives",
                },
                {
                    id: domains.AssetClass.CASH.toString(),
                    parentId: "0",
                    classification: "Cash",
                },
                {
                    id: domains.AssetClass.NO_ALLOCATION.toString(),
                    parentId: "0",
                    classification: "Other",
                }
            ];
        }

        onEditAfcModel(data: any) {
            this.classnsLoaded = false;
            this.afcModel = data;
            this.loadAfcModelClassns(this.afcModel.id);
            //console.log(`Editing ${data.id} asset class model`);
        }

        createTreeDataFromAfcClasses() {
            const tData = [];
            this.afcClasses.forEach(c => {
                const afcClass = {
                    id: c.classnId,
                    parentId: c.parentClassnId,
                    classification: c.name,
                };
                tData.push(afcClass);
            });
            return tData;
        }

        loadAfcModelClassns(afcModelId: number) {
            this.servicerService.getAfcClassifications(afcModelId).then(response => {
                this.afcClasses = response.data;
                if (this.afcClasses.length > 0) {
                    this.treeData = this.createTreeDataFromAfcClasses();
                    this.treeIsDirty = false;
                } else {
                    this.treeData = this.newTreeData();
                    this.treeIsDirty = true;
                }
                this.classnsLoaded = true;
            }, err => this.gs.showError(err));
        }

        lockModel(afcModel: domains.IAFAssetClassnModel) {
            if (window.confirm(`You are about to lock model ${afcModel.name}.\nAfter locking the model it can not be unlocked.\nAre you sure?`)) {
                this.servicerService.lockAfcModel(afcModel).then(resp => {
                    toastr.success(`Asset Class Model is now locked.`);
                    this.loadAfcModels(this.advisoryFirmId);
                }, err => this.gs.showError(err));
            }
        }

        enableDisable(afcModel: domains.IAFAssetClassnModel) {
            afcModel.isActive = !afcModel.isActive;
            this.servicerService.updateAfcModel(afcModel).then(resp => {
                toastr.success(`Asset Class Model has been successfully updated.`);
                this.loadAfcModels(this.advisoryFirmId);
            }, err => this.gs.showError(err));
        }

        saveAfcModel(afcModel: domains.IAFAssetClassnModel) {
            if (afcModel == null || afcModel.name == null || afcModel.name.length == 0) {
                toastr.warning(`Model name is required.`);
                return;
            }
            if (afcModel.id > 0) {
                // update
                this.servicerService.updateAfcModel(afcModel).then(resp => {
                    toastr.success(`Asset Class Model has been successfully updated`);
                    this.loadAfcModels(this.advisoryFirmId);
                }, err => this.gs.showError(err));
            } else {
                // create
                afcModel.advisoryFirmId = this.advisoryFirmId;
                this.servicerService.saveAfcModel(afcModel).then(resp => {
                    toastr.success(`Asset Class Model has been successfully created`);
                    this.afcModels.push(this.afcModel);
                    //this.newAfcModel();
                    this.loadAfcModels(this.advisoryFirmId);
                }, err => this.gs.showError(err));
            }
        }

        saveAfcClassn() {
            this.savingAfcClassn = true;

            // Create the classification object required by the server
            if (this.treeData.length > 0) {
                var newAfcClasses: domains.IAFAssetClassnClassn[] = [];
                this.treeData.forEach(d => {
                    var afcClass: domains.IAFAssetClassnClassn = {
                        id: 0,
                        name: d.classification,
                        aFAssetClassnModelId: this.afcModel.id,
                        classnId: d.id,
                        parentClassnId: d.parentId,
                        orderIndex: this.treeData.indexOf(d)
                    }
                    newAfcClasses.push(afcClass);
                });
            } else {
                toastr.warning(`You can not save an empty structure.`);
            }

            // Create the combined object to send to the server
            var saveObj: domains.IFAssetClassModelAndClassifications = {
                model: this.afcModel,
                classifications: newAfcClasses
            }

            this.servicerService.saveAfcClassifications(saveObj).then(resp => {
                this.afcClasses = resp.data;
                this.treeData = this.createTreeDataFromAfcClasses();
                this.treeIsDirty = false;
                toastr.success(`Asset Class Model has been saved.`);
            }, err => this.gs.showError(err));

            this.savingAfcClassn = false;
        }

        loadAfcModels(advisoryFirmId: number) {
            //console.log(`Loading AFC models for advisory firm ${advisoryFirmId}...`);
            this.afcModel = null;
            this.classnsLoaded = false;
            this.servicerService.getAfcModels(advisoryFirmId, false).then(response => {
                this.afcModels = response.data;
                this.onModelsChange({ afcModels: this.afcModels });
            }, err => this.gs.showError(err));
        }

        deleteAfcModels(afcModel: domains.IAFAssetClassnModel) {
            //console.log(`Deleting AFC model ${afcModel.id}...`);
            this.classnsLoaded = false;
            this.servicerService.deleteAfcModel(afcModel.id).then(response => {
                const ind = this.afcModels.indexOf(afcModel);
                if (ind >= 0) {
                    this.afcModels.splice(ind, 1);
                }
                this.loadAfcModels(this.advisoryFirmId);
            }, err => this.gs.showError(err));
        }

        $onInit(): void {
            this.iAmReady({ ctrl: this });
        }

        $onChanges(event: any): void {
            for (var key in event) {
                if (key === "advisoryFirmId") {
                    this.loadAfcModels(this.advisoryFirmId);
                }
            }
        }
    }


    class CuAfcModel implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                iAmReady: "&",
                onModelsChange: "&"
            };
            this.controller = CuAfcModelController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-afc-model.html";
        }
    }
    angular.module(Constants.APP).component("cuAfcModel", new CuAfcModel());
}